﻿
import { GroCommon } from './common';

$(function () {

    var deliveryNote = (function () {

        var $orderLink = $(".deliveryNote a.showPdf");

        var getPdf = function (orderNumber, fabricId, rowNumber) {
            GroCommon.blockUI();
            var url = "/api/delivery-note/get-deliverynote-pdf" + "?orderNumber=" + orderNumber + "&fabricId=" + fabricId + "&rowNumber=" + rowNumber;

            window.open(decodeURIComponent(url));
        };

        var init = function () {
            $orderLink.click(function () {

                var orderNumber = $(this).attr("cdata-orderNumber");
                var activePdf = $(this).attr("cdata-activePdf");
                var fabricId = $(this).attr("cdata-fabricID");
                var rowNumber = $(this).attr("cdata-rowNumber");
                var system = $(this).attr("cdata-system");

                if (activePdf === "True") {
                    getPdf(orderNumber, fabricId, rowNumber);
                } else {
                    switch (system) {
                        case "3":
                            {
                                break;
                            }
                        case "4":
                            {
                                break;
                            }
                        default:
                            {
                                break;
                            }
                    }
                }
            });
        };
        return {
            init: init
        };
    })();

    $(document).ready(function () {
        deliveryNote.init();
    });
});
